/* WordPress YouTube Embed Block */

document
  .querySelectorAll('figure.wp-block-embed-youtube .wp-block-embed__wrapper')
  .forEach((wrapper) => {
    const url = wrapper.textContent.trim();
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/
    );

    if (match) {
      const videoId = match[1];
      const iframe = document.createElement('iframe');
      iframe.width = '560';
      iframe.height = '315';
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      iframe.frameBorder = '0';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    }
  });
